/**
 * BT-037 — Modèle fichier officiel client (métadonnées, sans import réel).
 * Source alignée sur 00_PILOTAGE/templates/modele_officiel_037/*.manifest.json
 */
import manifest from "./officialClientModel037.manifest.json";

export const OFFICIAL_CLIENT_MODEL_BT = manifest.bt;
export const OFFICIAL_CLIENT_MODEL_VERSION = manifest.version;
export const OFFICIAL_CLIENT_MODEL_WORKBOOK_FR = manifest.workbookFr;
export const OFFICIAL_CLIENT_MODEL_WORKBOOK_EN = manifest.workbookEn;

export const OFFICIAL_CLIENT_MODEL_SECTIONS = manifest.sections;
export const OFFICIAL_CLIENT_MODEL_VALIDATION_RULES = manifest.validationRules;
export const OFFICIAL_CLIENT_MODEL_FUTURE_PREP = manifest.futurePreparation;

/** Sections obligatoires pour le remplissage initial */
export const OFFICIAL_CLIENT_REQUIRED_SECTION_IDS = manifest.sections
  .filter((s) => s.required)
  .map((s) => s.id);

/** Exemples fictifs — jamais de vraies données personnelles */
export const OFFICIAL_CLIENT_FICTIONAL_EXAMPLES = {
  fr: {
    dojo: {
      dojo_id: "demo-dojo-01",
      nom_dojo: "[DÉMO] Dojo exemple Nord",
      ville: "Ville à confirmer",
      statut: "à confirmer",
    },
    sensei: {
      personne_id: "demo-sensei-01",
      prenom: "[DÉMO]",
      nom: "Sensei Exemple",
      dojo_principal: "demo-dojo-01",
      titre: "Sensei",
    },
    sempai: {
      personne_id: "demo-sempai-01",
      prenom: "[DÉMO]",
      nom: "Sempai Exemple",
      peut_valider_titre: "non",
    },
    student: {
      etudiant_id: "demo-etu-01",
      prenom: "[DÉMO]",
      nom: "Étudiant Exemple",
    },
  },
  en: {
    dojo: {
      dojo_id: "demo-dojo-01",
      nom_dojo: "[DEMO] Sample North Dojo",
      ville: "City to confirm",
      statut: "to confirm",
    },
    sensei: {
      personne_id: "demo-sensei-01",
      prenom: "[DEMO]",
      nom: "Sample Sensei",
      dojo_principal: "demo-dojo-01",
      titre: "Sensei",
    },
    sempai: {
      personne_id: "demo-sempai-01",
      prenom: "[DEMO]",
      nom: "Sample Sempai",
      peut_valider_titre: "no",
    },
    student: {
      etudiant_id: "demo-etu-01",
      prenom: "[DEMO]",
      nom: "Sample Student",
    },
  },
};

export function getOfficialClientSection(sectionId) {
  return OFFICIAL_CLIENT_MODEL_SECTIONS.find((s) => s.id === sectionId) ?? null;
}

export function getSempaiTitleValidationDefault(locale = "fr") {
  return locale === "en" ? "no" : "non";
}

export function assertNoRealPersonalDataInExamples(examples) {
  const blob = JSON.stringify(examples).toLowerCase();
  const blocked = ["gauthier.karate", "marcel gauthier", "@gmail.com", "@hotmail", "819-", "613-"];
  return blocked.every((token) => !blob.includes(token));
}
